var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "01-legal-updates",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.5,18.2c-0.4-0.4-0.9-0.7-1.5-1c-0.5-0.2-1.1-0.3-1.7-0.3c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-1,0.6-1.5,1l-4.9,4.9V2.6 c-0.7-0.1-1.5-0.1-2.2-0.1c-0.8,0-1.5,0-2.2,0.1v20.5l-4.9-4.9c-0.4-0.4-0.9-0.7-1.5-1c-0.5-0.2-1.1-0.3-1.7-0.3 c-0.6,0-1.2,0.1-1.7,0.3c-0.5,0.2-1,0.6-1.5,1l10.3,10.3c0.8,0.8,2,1.3,3.2,1.3c1.2,0,2.3-0.5,3.2-1.3h0L45.5,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7,3.3v4.6C49.3,10.9,57,20.5,57,32c0,13.8-11.2,25-25,25S7,45.8,7,32c0-11.5,7.8-21.1,18.3-24.1V3.3 C12.2,6.3,2.5,18,2.5,32c0,16.3,13.2,29.5,29.5,29.5S61.5,48.3,61.5,32C61.5,18,51.8,6.3,38.7,3.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.4c18d7339927b7cbe9bbe12d0bca46ec.svg";
export { ForwardRef as ReactComponent };